class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
function fixCartDrawerPrices() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      document.querySelectorAll('.cart-item').forEach((item, index) => {

        const cartItem = cart.items[index];
        if (!cartItem) return;

        const details = item.querySelector('.cart-item__details');
        if (!details) return;

        let priceEl = details.querySelector('.custom-line-price');

        if (!priceEl) {
          priceEl = document.createElement('div');
          priceEl.className = 'custom-line-price';
          priceEl.style.margin = '6px 0';
          priceEl.style.fontWeight = '700';
          details.insertBefore(priceEl, details.children[1]);
        }

        const finalPrice =
          (cartItem.final_line_price / 100)
            .toFixed(2)
            .replace('.', ',') + ' €';

        const originalPrice =
          (cartItem.original_line_price / 100)
            .toFixed(2)
            .replace('.', ',') + ' €';

        if (cartItem.original_line_price > cartItem.final_line_price) {
          priceEl.innerHTML =
            '<s style="font-size:16px; font-weight:400; opacity:.6; margin-right:8px;">' +
            originalPrice +
            '</s>' +
            '<span>' + finalPrice + '</span>';
        } else {
          priceEl.innerHTML = finalPrice;
        }

        details.childNodes.forEach(node => {
          if (
            node.nodeType === Node.TEXT_NODE &&
            node.textContent.includes('€')
          ) {
            node.textContent = '';
          }
        });

        details.querySelectorAll('*').forEach(el => {
          const text = el.textContent.trim();

          if (
            /^€?\s?\d/.test(text) &&
            !el.classList.contains('custom-line-price') &&
            !el.closest('.custom-line-price')
          ) {
            el.style.display = 'none';
          }
        });

      });
    });
}

document.addEventListener('DOMContentLoaded', fixCartDrawerPrices);

document.addEventListener('click', function() {
  setTimeout(fixCartDrawerPrices, 300);
  setTimeout(fixCartDrawerPrices, 1000);
});

const cartDrawerObserver = new MutationObserver(fixCartDrawerPrices);

cartDrawerObserver.observe(document.body, {
  childList: true,
  subtree: true
});
function translateFreeGiftText() {
  const walker = document.createTreeWalker(
    document.querySelector('.cart-drawer') || document.body,
    NodeFilter.SHOW_TEXT
  );

  let node;

  while ((node = walker.nextNode())) {
    if (node.nodeValue.includes('Free Gift')) {
      node.nodeValue = node.nodeValue.replaceAll('Free Gift', 'Gratis dazu');
    }
  }
}

document.addEventListener('DOMContentLoaded', translateFreeGiftText);

document.addEventListener('click', function() {
  setTimeout(translateFreeGiftText, 300);
  setTimeout(translateFreeGiftText, 1000);
});

const freeGiftObserver = new MutationObserver(translateFreeGiftText);

freeGiftObserver.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true
});